export const getShopList = state => {
    return state.list
}

export const getShopDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/shop/getters.js